module.exports = __webpack_public_path__ + "SC03-5.b2ec55a8.png";